const ReplyIcon = () => {
  return (
    <div>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="6" fill="#FFE6E6" />
        <g clip-path="url(#clip0_4209_18209)">
          <path
            d="M10.3333 9.50002V6.16669L4.5 12L10.3333 17.8334V14.4167C14.5 14.4167 17.4167 15.75 19.5 18.6667C18.6667 14.5 16.1667 10.3334 10.3333 9.50002Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0_4209_18209">
            <rect
              width="20"
              height="20"
              fill="white"
              transform="translate(2 2)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default ReplyIcon;
